import { useState } from "react";
import { ToolBtn } from "../ToolBtn";
import secondaryComponents from "../..";
import primaryComponents from "../../../primaryComponents";
import { useCheckoutHelper } from "../../../../hooks/useCheckoutHelper";
import { useGetPharmacyOption } from "../../../../hooks/api/queries/useOrder";
import { CreatePharmacyIntervention } from "./CreatePharmacyIntervention";
import { RoutedModal } from "../../../common";

export const CheckoutPharmacyIntervention = ({ btnStyle }) => {
  const [isOrderType, setIsOrderType] = useState(false);
  const [isCreateIntervention, setIsCreateIntervention] = useState(false);
  const { intervention, setIntervention } = useCheckoutHelper();
  const { data, isLoading } = useGetPharmacyOption({
    isEnabled: isOrderType,
  });
  const interventionList = data?.intervention_types || [];
  const interventionLabel = intervention?.intervention_types
    ?.map((selectedIntervention) => {
      const result = interventionList?.find(
        (item) => `${item?.value}` === `${selectedIntervention}`,
      );

      return result?.label;
    })
    ?.join(", ");

  return (
    <>
      <div className="w-100">
        <ToolBtn
          text="Intervention"
          borderColor={"transparent"}
          onClick={() => setIsOrderType(true)}
          style={btnStyle}
          contentText={interventionLabel || null}
        />
      </div>

      <secondaryComponents.Modal
        isActive={isOrderType}
        width={500}
        closeModal={() => setIsOrderType(false)}
      >
        <div className="d-flex flex-column p-2" style={{ gap: "15px" }}>
          <div>
            <h4 className="mb-0">Select Intervention</h4>
            <hr />
          </div>

          <secondaryComponents.LoaderHelper
            isLoading={isLoading}
            classNames={"mt-4"}
          >
            <div className="d-flex flex-column w-100" style={{ gap: "10px" }}>
              <primaryComponents.MultipleSelectField
                label={
                  <>
                    Intervention{" "}
                    <span
                      className="purple--text cursor-pointer"
                      onClick={() => setIsCreateIntervention(true)}
                    >
                      (Create)
                    </span>
                  </>
                }
                options={interventionList}
                nameKey={"label"}
                idKey={"value"}
                isRequired
                giveControl={false}
                value={intervention?.intervention_types?.map(
                  (selectedIntervention) => {
                    const result = interventionList?.find(
                      (item) => `${item?.value}` === `${selectedIntervention}`,
                    );

                    return {
                      label: result?.label,
                      value: result?.value,
                    };
                  },
                )}
                placeholder="Select intervention..."
                onChange={(interventions) => {
                  setIntervention({
                    ...intervention,
                    intervention_types: interventions?.map(
                      (item) => item?.value,
                    ),
                  });
                }}
              />

              {/* <TextAreaV2 N/> */}
            </div>
          </secondaryComponents.LoaderHelper>

          <primaryComponents.Button
            classNames={"btn btn--primary cover mt-3"}
            onClick={() => setIsOrderType(false)}
          >
            Continue
          </primaryComponents.Button>
        </div>
      </secondaryComponents.Modal>

      <RoutedModal
        isActive={isCreateIntervention}
        width={400}
        style={{ height: "auto" }}
        closeModal={() => setIsCreateIntervention(false)}
      >
        <CreatePharmacyIntervention
          closeModal={() => setIsCreateIntervention(false)}
        />
      </RoutedModal>
    </>
  );
};
